

<template>
  <div id="categories-container" :class="{biggerTopDesktop: scrollPosition<=45 && !isPda}">
    <div id="search-product-input-container">
      <input
        type="text"
        id="search-product-input"
        v-model="searchInput"
        @input="onSearchProductInput()"
        placeholder="Search"
      />
      <font-awesome-icon @click="clearSearchInput()" icon="times" id="clear-search-input" />
    </div>
    <div id="categories" :class="{smallerHeight: scrollPosition<=45 && !isPda}">
      <div class="pda-food-categories-container">
        <FoodCategory
          v-for="category in categories"
          v-bind:key="category.id"
          v-bind:category="category"
          :isPda="isPda"
        ></FoodCategory>
      </div>
    </div>
  </div>
</template>

<script>
import FoodCategory from "./FoodCategory";

export default {
  name: "PdaDesktopCategories",
  components: {
    FoodCategory
  },
  computed: {
    categories() {
      return this.$store.getters.getCategories;
    },
  },
  props: ["isPda"],
  data() {
    return {
      searchInput: "",
      timer: undefined,
      scrollPosition: 0
    };
  },
  methods: {
    onSearchProductInput() {
      clearTimeout(this.timer)

      if (this.searchInput != null && this.searchInput != '' && this.searchInput.trim().length != 0) {
        this.timer = setTimeout(() => {
          this.$store.dispatch("setSearchProductsInput", this.searchInput);
        }, 530)
      } else {
        this.$store.dispatch("setSearchProductsInput", "");
      }

    },

    clearSearchInput() {
      clearTimeout(this.timer)
      this.searchInput = "";
      this.$store.dispatch("setSearchProductsInput", "");
    },
    watchSrollPosition() {
      this.scrollPosition = window.scrollY;
    }

  },
  mounted() {
    window.addEventListener("scroll", this.watchSrollPosition);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.watchSrollPosition);
  },
};
</script>

<style scoped>
#categories-container {
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.16), 3px 3px 4px rgba(0, 0, 0, 0.23);
  background: white;
  border-radius: 18px 18px 10px 18px;
  position: fixed;
  left: 12px;
  top: 60px;
  width: 14.5vw;
  min-width: 220px;
  z-index: 201;
}

.pda-food-categories-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.biggerTopDesktop {
  top: 130px !important;
}

#categories {
  padding: 0% 4% 100px 4%;
  color: gray;
  font-weight: bold;
  max-height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.smallerHeight {
  max-height: 65vh !important;
}

#categories::-webkit-scrollbar {
  width: 12px;
}

#categories::-webkit-scrollbar-thumb {
  background-color: #3b3838;
  border-radius: 25px;
  border: 3px solid white;
  z-index: 0;
}

#search-product-input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  box-shadow: inset 1px 1px 1px 0 rgba(0, 0, 0, 0.2);
  padding-left: 1px;
  background: #f9f9f9;
  width: 86%;
  height: 35px !important;
  margin-left: 7%;
  margin-bottom: 16px;
  margin-top: 10px;
}

#search-product-input {
  padding: 2px 3px 2px 6px;
  width: 98%;
  font-size: 16px;
  border-radius: 6px;
  font-weight: 500 !important;
}

#clear-search-input {
  width: 7%;
  color: #575757 !important;
  cursor: pointer;
  padding-right: 6px;
}

@media screen and (max-width: 1200px) {
  #categories-container {
    min-width: 200px;
  }
}

@media screen and (max-width: 1100px) {
  #categories-container {
    min-width: 185px;
  }

  #categories {
    padding: 0% 5% 100px 2%;
  }

  #search-product-input-container {
    margin-left: 5%;
    width: 85%;
  }
}
</style>



